import { RadioGroup } from "@portal/BaseComponents/Radio/AntRadio";
import {
  GenericRadioChangeEvent,
  GenericRadioOptionType,
} from "@portal/BaseComponents/Radio/types";
import { invoiceFiltersAtom } from "@portal/store/Filters/Invoices/invoice-filter";
import { invoiceDerivedStatusOptions } from "@portal/store/Filters/Invoices/predicate";
import { tableAtom } from "@portal/store/table/table";
import { InvoiceDerivedStatus } from "@portal/types/entities/invoice";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";
import { InvoiceFilterProps } from "../InvoiceFilters";
import { useMemo } from "react";
import { invoiceStatusesConfig } from "../../predicate";

function DerivedStatusFilter(props: InvoiceFilterProps) {
  const [invoiceFilters, setInvoiceFilters] = useAtom(invoiceFiltersAtom);
  const setTableValue = useSetAtom(tableAtom);

  function derivedStatusesOption() {
    if (
      !props.actionFeatures?.draftInvoice &&
      !props.actionFeatures?.draftMetric
    ) {
      return invoiceDerivedStatusOptions.filter(
        (option) =>
          (option as GenericRadioOptionType<InvoiceDerivedStatus>).value !==
          "DRAFT"
      );
    }
    return invoiceDerivedStatusOptions;
  }

  function onChange(event: GenericRadioChangeEvent<InvoiceDerivedStatus>) {
    setInvoiceFilters((filter) => {
      return produce(filter, (draft) => {
        draft.ui_filters.view_status = event.target.value ?? "ALL";
        draft.filterValues.statuses = event.target.value==='OPEN' ?invoiceStatusesConfig.OPEN:
          props.invoiceStatusConfig[event.target.value ?? "ALL"];
      });
    });

    setTableValue((table) => {
      return { ...table, currentPage: 1 };
    });
  }

  const computedInvoiceDerivedStatusOptions = useMemo(derivedStatusesOption, [
    derivedStatusesOption,
  ]);

  return (
    <RadioGroup
      optionType="button"
      options={computedInvoiceDerivedStatusOptions}
      buttonStyle="solid"
      defaultValue={invoiceFilters.ui_filters.view_status}
      onChange={onChange}
      value={invoiceFilters.ui_filters.view_status}
    />
  );
}

export { DerivedStatusFilter };
